export class ReportChartMetaData {
    calcRef: number;
    name: string;
    units: string;
    availableChartTypes: string;
    selectedKpiChartType: string;
    definition: string;
    noDataMessage: string;
}
